import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/about.scss";
import { Link } from "react-router-dom";

function About() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="about">
      <Header />

      <main className="about-main">
        <section className="about-hero">
          <h1 className="about-hero__title">About Us</h1>
          <div className="about-hero__divider" />
          <div className="about-hero__image">
            <img
              src="/main/a1.avif"
              alt="About Us"
              decoding="async"
              width="1120"
              height="420"
            />
          </div>
        </section>

        <section className="about-intro">
          <div className="about-container">
            <p className="about-intro__headline">
              At Denowl, home comes first — We believe in creating and sourcing
              pieces that move with you and are meant to be enjoyed over a
              lifetime – from home to home, generation to generation. For us,
              that means exceptionally crafted, built-to-last, and beautifully
              designed furnishings.
            </p>
          </div>
        </section>

        <section className="about-concierge">
          <div className="about-container about-split">
            <div className="about-split__media">
              <img
                src="/main/a2.avif"
                alt="Design Concierge"
                loading="lazy"
                decoding="async"
                width="640"
                height="520"
              />
            </div>
            <div className="about-split__content">
              <div className="about-eyebrow">
                COMPLIMENTARY INTERIOR DESIGN SERVICES
              </div>
              <h2 className="about-heading">Design Concierge</h2>
              <p className="about-copy">
                Whether you’re starting from scratch, need one key piece, or a
                few finishing touches, we’re here to de-stress the design
                process. Our expert Associates can design room plans, help you
                choose the best furniture and fabrics for your lifestyle, and
                show you exactly how it will look in your home with 3D
                renderings. And it’s all free of charge.
              </p>
              <Link to="/contact" onClick={toTop} className="about-button">
                Book an Appointment
              </Link>
            </div>
          </div>
        </section>

        <section className="about-history">
          <div className="about-container">
            <h2 className="about-sectionTitle">Our History</h2>
            <div className="history-grid">
              <article className="history-card">
                <img
                  src="/main/a3-1.avif"
                  alt="The aha moment"
                  loading="lazy"
                  decoding="async"
                  width="360"
                  height="240"
                />
                <div className="history-card__body">
                  <h3 className="history-card__title">The aha moment</h3>
                  <p className="history-card__copy">
                    The idea for Denowl came to founder Rob Forbes in 1998, when
                    he tried to furnish his apartment with the clean, simple
                    classics he’d come to appreciate while living in London.
                  </p>
                </div>
              </article>

              <article className="history-card">
                <img
                  src="/main/a3-2.avif"
                  alt="Taking action"
                  loading="lazy"
                  decoding="async"
                  width="360"
                  height="240"
                />
                <div className="history-card__body">
                  <h3 className="history-card__title">Taking action</h3>
                  <p className="history-card__copy">
                    Realizing there had to be a better way, Rob and a small team
                    brought modern design closer to customers with a service
                    model built around access, expertise, and authenticity.
                  </p>
                </div>
              </article>

              <article className="history-card">
                <img
                  src="/main/a3-3.avif"
                  alt="Feeling the love"
                  loading="lazy"
                  decoding="async"
                  width="360"
                  height="240"
                />
                <div className="history-card__body">
                  <h3 className="history-card__title">Feeling the love</h3>
                  <p className="history-card__copy">
                    Architects, interior designers, and design enthusiasts
                    responded immediately, and our approach helped shape a new
                    generation of modern spaces — at home and beyond.
                  </p>
                </div>
              </article>
            </div>
          </div>
        </section>

        <section className="about-quote">
          <div className="about-container about-quote__inner">
            <p className="about-quote__text">
              By giving people access to the best in authentic modern design, we
              made Denowl.
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default About;
